import useGlobalContext from "client/context/GlobalContext";
import { useMainPortal } from "client/hooks/useMainPortal";
import type { FocusTargetValue } from "focus-trap";
import FocusTrap from "focus-trap-react";
import React from "react";
import ModalContent from "../modal-content/modal-content";
import {
  GlobalStyle,
  StyledModal,
  StyledModalBackdrop,
  StyledOverlay,
  StyledPopup,
} from "./autosuggest-modal.styles";

export type AutosuggestModalProps = object;

const AutosuggestModal: React.FC<AutosuggestModalProps> = () => {
  const { closeModal } = useGlobalContext();
  const modalContentRef = React.useRef<HTMLDivElement>(null);
  const Portal = useMainPortal();

  return (
    <Portal>
      <StyledModalBackdrop onClick={closeModal} />
      <StyledModal aria-modal role="dialog">
        <FocusTrap
          focusTrapOptions={{
            allowOutsideClick: true,
            fallbackFocus: () => modalContentRef.current as FocusTargetValue,
            initialFocus: false,
          }}
        >
          <StyledOverlay ref={modalContentRef}>
            <StyledPopup>
              <GlobalStyle />
              <ModalContent />
            </StyledPopup>
          </StyledOverlay>
        </FocusTrap>
      </StyledModal>
    </Portal>
  );
};

export default AutosuggestModal;
